import React from 'react';
import { Box, Tooltip, Badge, Avatar } from '@mui/material';
import {
  Forum as ForumIcon,
  Contacts as ContactsIcon,
  Group as GroupIcon,
  Logout as LogoutIcon,
} from '@mui/icons-material';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { setView, setRightContent } from '../redux/chat.redux';
import type { View } from '../redux/chat.redux';
import { api } from '../api/chat';

const NAV_ITEMS: { key: View; icon: React.ReactElement; label: string }[] = [
  { key: 'conversations', icon: <ForumIcon />, label: '会话' },
  { key: 'contacts', icon: <ContactsIcon />, label: '通讯录' },
  { key: 'groups', icon: <GroupIcon />, label: '群聊' },
];

export default function IconRail() {
  const dispatch = useAppDispatch();
  const view = useAppSelector((s) => s.chat.view);
  const conversations = useAppSelector((s) => s.chat.conversations);
  const pendingRequests = useAppSelector((s) => s.chat.pendingRequests);
  const me = useAppSelector((s) => s.user.user);

  const totalUnread = conversations.reduce((sum, c) => sum + c.unread, 0);

  return (
    <Box
      sx={{
        width: 64,
        py: 2,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: 'primary.main',
        color: '#fff',
      }}
    >
      {NAV_ITEMS.map((item) => {
        const active = view === item.key;
        let badge: React.ReactElement | undefined;
        if (item.key === 'conversations' && totalUnread > 0) {
          badge = (
            <Badge badgeContent={totalUnread > 99 ? '99+' : totalUnread} color="error" max={99}>
              {item.icon}
            </Badge>
          );
        } else if (item.key === 'contacts' && pendingRequests.length > 0) {
          badge = (
            <Badge variant="dot" color="error">
              {item.icon}
            </Badge>
          );
        }
        return (
          <Tooltip key={item.key} title={item.label} placement="right">
            <Box
              onClick={() => dispatch(setView(item.key))}
              sx={{
                width: 48,
                height: 48,
                mb: 1.5,
                borderRadius: 2,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                fontSize: 28,
                bgcolor: active ? 'rgba(255,255,255,0.18)' : 'transparent',
                '&:hover': { bgcolor: 'rgba(255,255,255,0.12)' },
              }}
            >
              {badge ?? item.icon}
            </Box>
          </Tooltip>
        );
      })}

      <Box sx={{ flexGrow: 1 }} />

      <Tooltip title="我的资料" placement="right">
        <Avatar
          src={me?.avatar}
          onClick={() => dispatch(setRightContent({ type: 'panel', panel: 'profile' }))}
          sx={{ width: 40, height: 40, cursor: 'pointer', bgcolor: 'primary.light' }}
        >
          {me?.nickname?.[0] || me?.username?.[0]}
        </Avatar>
      </Tooltip>
      <Tooltip title="退出登录" placement="right">
        <Box
          onClick={async () => {
            try {
              await api.logout();
            } catch {
              /* ignore */
            }
            window.location.href = '/login';
          }}
          sx={{
            mt: 1.5,
            width: 44,
            height: 44,
            borderRadius: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            '&:hover': { bgcolor: 'rgba(255,255,255,0.12)' },
          }}
        >
          <LogoutIcon fontSize="small" />
        </Box>
      </Tooltip>
    </Box>
  );
}
